<template>
	<v-dialog :model-value="dialog" width="560" persistent>
		<v-card>
			<v-card-title class="text-h1 font-weight-bold">
				Override Hotkey
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" @click="close" variant="plain">
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div class="text-body-2">
					You will override the Hotkey already assigned to this slot. Do you wish to continue?
				</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn variant="text" @click="close" color="primary">
					Cancel
				</v-btn>
				<v-btn variant="flat" color="primary" @click="overrideHotKey()">
					Confirm
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "OverrideHotKeyConfirmationDialog",

	props: ["dialog", "options"],

	emits: ["close"],

	methods: {
		overrideHotKey() {
			this.options.confirm();
			this.close();
		},

		close() {
			// Remove border from target hotkey container
			if (document.querySelector(".drop-target-container")) {
				document.querySelector(".drop-target-container").classList.remove("drop-target-container");
			}
			this.$emit("close");
		}
	}
};
</script>
